<template>
  <div v-if="ready" class="weeklybrands">
    <ProductTab
      :categories.sync="categories"
      :selectedTab.sync="selectedTab"
      :showCategoryMenu.sync="isCategoryShow"
    />

    <div class="filter-bar">
      <div class="filter-bar--row">
        <div class="filter-bar-pi-point">
          <img
            :src="piPointImage"
            alt="pi-point"
            class="filter-bar-pi-point__icon"
          />
          <div class="filter-bar-pi-point__amount">{{ piPoints }}</div>
        </div>
      </div>
    </div>

    <div v-if="!nameOnly" class="banner">
      <img
        onerror="this.classList.add('error-img')"
        :src="curationList.imagePath"
        class="mainImage"
        :class="{ small: type == 2 }"
      />
      <img
        v-if="type == 1"
        class="error-holder"
        src="@/assets/img/placholder_1200.svg"
      />
      <img v-else class="error-holder" src="@/assets/img/placholder_512.svg" />
    </div>
    <div class="curation-title">{{ title }}</div>
    <div v-if="curationContent == 2" class="tab-container">
      <div class="row text-center">
        <div
          class="col tab-item"
          :class="{ 'tab-item--active': tabValue == 1 }"
          @click="tabValue = 1"
        >
          優惠商品
        </div>
        <div
          class="col tab-item ml-2"
          :class="{ 'tab-item--active': tabValue == 2 }"
          @click="tabValue = 2"
        >
          活動辦法
        </div>
      </div>
    </div>

    <div
      class="filter-container"
      v-if="filters.length > 1"
      v-show="tabValue == 1"
    >
      <filter-carousel
        v-if="filters.length > 1"
        class="filter-carousel"
        :filterList="filters"
        @getActiveFilter="getActiveFilter"
      />
    </div>
    <div v-show="tabValue == 1" class="container list-container">
      <div class="row">
        <div
          v-for="product in paginationProducts"
          :key="product.bid"
          class="col col-6"
        >
          <div class="product-outer">
            <product-block
              v-bind="{
                info: product,
                modifier: 'm',
                gaEvent: '010',
              }"
            />
          </div>
        </div>
      </div>
    </div>

    <div v-show="tabValue == 2" class="container desc-container">
      <div v-html="curationList.curationDescription"></div>
    </div>
    <AboutBlock />
  </div>
  <Spinner v-else bgc="#f6f6f6" />
</template>
<script>
import ProductTab from '@/components/product/ProductTab'
import FilterCarousel from '@/components/curation/FilterCarousel'
import ProductBlock from '@/components/ProductBlock'
import Spinner from '@/components/shared/Spinner.vue'
import AboutBlock from '@/components/shared/AboutBlock.vue'
export default {
  name: 'CurationPage',
  components: {
    FilterCarousel,
    ProductBlock,
    Spinner,
    AboutBlock,
    ProductTab
  },
  data() {
    return {
      type: 1,
      nameOnly: false,
      curationGuid: 0,
      themeIndex: 0,
      tabValue: 1,
      curationList: {},
      filters: [],
      activeFilter: 0,
      filteredProducts: [],
      ready: false,
      isWeeklyHot: true,
      title: '',
      curtaionContent: 2,
      show: 10,
      inTheEnd: false,
      selectedTab: 0,
      categories: [],
      isCategoryShow: false,
      piPointImage: require('@/assets/img/icon/pi-point.svg'),
      piPoints: '讀取中',
    }
  },
  created() {
    this.curationGuid = this.$route.params.id
    this.themeIndex = this.$route.query.theme
    this.getCurationDeals()
    window.addEventListener('scroll', this.handleScroll)
  },
  mounted() {
    const piInfo = localStorage.getItem('PI_POINTS')
    if (piInfo != null) this.piPoints = piInfo
    else this.pollingPipoint()
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    getActiveFilter(activeFilter) {
      this.activeFilter = activeFilter
    },
    getProducts() {
      if (this.curationList.categoryPreviews.length <= 0) {
        console.log('No Products.')
      } else {
        this.filteredProducts = this.curationList.categoryPreviews[
          this.activeFilter
        ].productPreviews
      }
    },
    getCurationDeals() {
      api
        .getCurationDeals(this.curationGuid, this.$route.query.preview)
        .then(res => {
          this.curationList = res.data.curationList
          if (
            localStorage.getItem('PREVIEW_MODE') != 0 ||
            this.$moment().isBetween(
              this.curationList.startTime,
              this.curationList.endTime
            )
          ) {
            if (
              this.curationList.applyType == 2 &&
              this.curationList.outerUrl != ''
            ) {
              this.$router.replace({
                name: 'externalLink',
                params: { link: this.curationList.outerUrl },
              })
              return
            }
            this.title = res.title
            this.themeIndex = res.data.curationList.themeStyle
            this.type = res.data.curationList.curationType
            this.curationContent = res.data.curationList.curationContent
            this.tabValue = this.curationContent == 1 ? 2 : 1
            if (!this.type) this.nameOnly = true
            this.filters = [...res.data.curationList.categoryPreviews].map(
              (cat, idx) => {
                return { value: idx, text: cat.categoryName }
              }
            )
            this.getProducts()
            this.ready = true
          } else {
            this.$bus.$emit('callAllert', {
              messageContent: '目前非活動期間！',
              callback: () => {
                this.$router.replace({
                  name: 'home',
                })
              },
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    handleScroll() {
      if (this.inTheEnd) return
      const scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      const scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight
      const windowHeight = window.screen.height
      const scrollBottom = scrollTop + windowHeight
      if (scrollBottom >= scrollHeight - 20) {
        this.show += 10
        if (this.show > this.filteredProducts.length) this.inTheEnd = true
      }
    },
    pollingPipoint() {
      let checkTime = 3
      const timer = setInterval(() => {
        checkTime--
        if (localStorage.getItem('PI_POINTS')) {
          this.piPoints = localStorage.getItem('PI_POINTS')
          clearInterval(timer)
        } else if (!checkTime) {
          this.piPoints = '取得失敗'
          clearInterval(timer)
        }
      }, 1500)
    }
  },
  computed: {
    paginationProducts() {
      return this.filteredProducts.slice(0, this.show)
    },
  },
  watch: {
    activeFilter() {
      this.inTheEnd = false
      this.show = 10
      this.getProducts()
    },
  },
}
</script>

<style scoped lang="scss">
.weeklybrands {
  position: relative;
  height: 100%;
  .banner {
    margin-top: 100px;
    padding: 20px 4.8%;
    font-size: 0;
    min-height: 177px;
    .mainImage {
      width: 100%;
      border-radius: 16px;
      overflow: hidden;
      display: block;
      background: url('../../assets/img/placholder_1200.svg');
      background-size: contain;
      background-repeat: no-repeat;
      &.small {
        background: url('../../assets/img/placholder_512.svg');
        width: 50%;
        margin: auto;
      }
    }
    img {
      width: 100%;
      &.error-img {
        display: none;
        & + .error-holder {
          display: block;
        }
      }
      &.error-holder {
        display: none;
      }
    }
  }
  .container {
    background-color: transparent;
  }
  ::v-deep .product-block {
    h2 {
      font-weight: bold;
    }
    h3 {
      font-size: 14px;
    }
  }
  .tab-item {
    height: 47px;
    font-size: 19px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #1da7fc;
    font-weight: bold;
    padding: 10px 0;
    background-color: rgba($color: #1da7fc, $alpha: 0.1);
    border-radius: 12px 12px 0 0;
    &--active {
      color: #fff;
      background-color: #1da7fc;
      opacity: 1;
    }
  }
}
.curation-title {
  padding: 20px 4.8% 10px;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.56px;
  color: #383838;
  background-color: #f3f5f8;
}
.tab-container {
  padding: 10px 4.8% 18px;
  background-color: #f3f5f8;
  > .row {
    margin-left: 0;
    margin-right: 0;
  }
}

.filter-container {
  padding: 18px 0 20px;
  background-color: #f3f5f8;
}

.list-container {
  padding: 20px 4.8%;
  .row {
    margin: 0;
    .col {
      padding: 0px;
      &:nth-child(odd) {
        padding-right: 8px;
      }
      &:nth-child(even) {
        padding-left: 8px;
      }
    }
  }

  .product-outer {
    background-color: #ffffff;
    padding-bottom: 20px;
    height: 100%;
    .product-block {
      height: 100%;
    }
    // padding: 8px;
    // border-radius: 4px;
    // box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.08);
  }
}

.desc-container {
  padding: 16px 20px 20px;
  margin-bottom: 44px;
}

.filter-bar {
  margin-bottom: 1px;
  padding: 10px 18px;
  height: 50px;
  background: white;
  z-index: 12;
  position: fixed;
  width: 100%;
  top: 50px;
  border-bottom: solid 0.5px #ddd;
  &--row {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &-pi-point {
    height: 30px;
    padding: 5px 10px;
    border-radius: 24px;
    border: solid 1px #bbbbbb;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #1da7fc;
    display: flex;
    align-items: center;
    &__icon {
      width: 16px;
      height: 18px;
    }
  }

}
</style>
